import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { can } from "../../utils/can";

export default function TermsCondition() {
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";
    const token = localStorage.getItem("adminToken");
  
    const [content, setContent] = useState("");      // CKEditor content
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
  
    // Fetch existing Privacy Policy
    const fetchPolicy = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_URL}/api/admin/terms-list`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (data.success) {
          setContent(data.data?.[0]?.content || "");
        } else {
          setContent("");
        }
      } catch (err) {
        console.error("Fetch Terms & Conditions Error:", err);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchPolicy();
    }, []);
  
    // Handle update
    const handleUpdate = async (e) => {
      if(can("terms_and_conditions","edit") === false){
              alert("You don't have permission.");
              return;
            }

      e.preventDefault();
      setError("");
      setMessage("");
  
      if (!content.trim()) {
        setError("Terms & Conditions content cannot be empty.");
        return;
      }
  
      try {
        setLoading(true);
        const res = await fetch(`${API_URL}/api/admin/terms-create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ content }),
        });
        const data = await res.json();
        if (data.success) {
          setMessage("Terms & Conditions updated successfully!");
        } else {
          setError(data.message || "Failed to update Terms & Conditions.");
        }
      } catch (err) {
        console.error("Update Error:", err);
        setError("Server error occurred.");
      } finally {
        setLoading(false);
      }
    };
  
    const handleEditorChange = useCallback((event, editor) => {
      setContent(editor.getData());
    }, []);

  return (
    <div class="container body">
      <div class="main_container">
        <Sidebar />
        <Header pageTitle="Terms & Conditions" />
        {/* page */}
        <div className="right_col" role="main">
          {/* top tiles */}
       
          {/* /top tiles */}
          {/* body card start */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Terms &amp; Conditions Entry</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>
               
               
              </ul>
              <div className="clearfix" />
            </div>
            <div className="x_content">
                          <form onSubmit={handleUpdate}>
                            <div className="row">
                              <div className="col-12 col-sm-12 pr-lg-0 mb-3">
                                <label>Add Terms & Conditions</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={content}
                                    onChange={(event, editor) => {
                                      setContent(editor.getData());
                                    }}
                                    disabled={loading}
                                  />
            
            
                                {error && <div style={{ color: "red", marginTop: "5px" }}>{error}</div>}
                                {message && <div style={{ color: "green", marginTop: "5px" }}>{message}</div>}
                              </div>
            
                              <div className="col-12" />
                              <div className="col-12 col-sm-12 pr-lg-0 text-right">
                                <button type="submit" className="btn sitebtn" disabled={loading}>
                                  {loading ? "Updating..." : "Update"}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
          </div>
          {/* bod card end */}
        
        
        </div>

        {/* page end */}
        <Footer />

      </div>
    </div>
  );
}